angular.module('impactx.rfx').controller('RFXSupplierRFQHRecommendationCtrl', [
    '$scope',
    'TranslationService',
    '$mdDialog',
    'dataGen',
    'BackService',
    'RFXSupplierService',
    'LoadingDialogService',
    RFXSupplierRFQHRecommendationCtrl
]);

function RFXSupplierRFQHRecommendationCtrl($scope, TranslationService, $mdDialog, dataGen, BackService, RFXSupplierService, LoadingDialogService) {
    var self = this;
    self.recommendationText = {value: null};

    $scope.trns = {
        abort: TranslationService.get('abort'),
        required:TranslationService.get('required')
    };

    self.sendRecommendationAfterSave = function () {
        dataGen.postAsForm({}, {recommendationText: self.recommendationText.value, data: self.data},
            "/rfx/supplier/createrfqh/sendrecommendation", false, true).then(function () {
            if (self.locationWatcher) {
                self.locationWatcher();
            }
            $mdDialog.hide();
            BackService.back();
            LoadingDialogService.stop();
        }, function (){
            $mdDialog.hide(true);
            LoadingDialogService.stop();
        });
    };

    self.sendRecommendation = function () {
        self.requestInProgress = true;
        self.cacheAllItemComments();
        LoadingDialogService.start();
        dataGen.postAsForm({}, {data: self.data}, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.saveAttachmentsEncrypted) {
                RFXSupplierService.saveItemCommentsEncrypted(self.data.id).then(function () {
                    self.sendRecommendationAfterSave();
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    self.restoreAllItemComments();
                });
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                RFXSupplierService.saveItemComments(response.data.tokens).then(function () {
                    self.sendRecommendationAfterSave();
                }, function () {
                    LoadingDialogService.stop();
                    self.requestInProgress = false;
                    self.restoreAllItemComments();
                });
            }
        }, function () {
            LoadingDialogService.stop();
            self.requestInProgress = false;
            self.restoreAllItemComments();
        });
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.cacheAllItemComments = function () {
        angular.forEach(self.data.contracts, function (contract) {
            RFXSupplierService.cacheItemListComments(contract.items);
        });
    };

    self.restoreAllItemComments = function () {
        angular.forEach(self.data.contracts, function (contract) {
            RFXSupplierService.restoreItemListComments(contract.items);
        });
    };
}